import { find, get } from 'lodash';
import { useContext } from 'react';
import { MainMenuContext } from '../context/main-menu-context';
import { useMenus } from './use-menus';
import { useSite } from './use-site';
import { useEnv } from './use-env';
export var useMainMenu = function () {
  var site = useSite();
  var env = useEnv();
  var allMenus = useMenus() || [];
  var context = useContext(MainMenuContext);
  var menuSlug = get(site, 'mainMenu.slug', env.MAIN_MENU_SLUG || '');
  if (menuSlug) {
    var menu = find(allMenus, function (menu) {
      return menu.slug === menuSlug;
    });
    return context || menu;
  }
  return context;
};